import GetBrowser from './GetBrowser';

export const TestUserAgent = map => {
    let obj;
    let s = 'default';
    let name;
    for (name in map) {
        if (!map.hasOwnProperty(name)) continue;
        obj = map[name];
        if (obj.regExp.test(navigator.userAgent) || (typeof obj.browsersRegExp !== 'undefined' && obj.browsersRegExp.test(GetBrowser()))) {
            s = name;
        }
    }
    return s;
};

export default TestUserAgent;
